export default "__VITE_ASSET__BxjX7apH__"